module.exports = __webpack_public_path__ + "img/img-app@2x.16ec632b.png";